export default __webpack_public_path__ + "static/blob14-fe5f1a28735b4726b6e5f57c2b96e93c.svg";